import React, { useState } from 'react';
import Modal from 'react-modal';
import { ActionLink } from 'components/shared';
import { Button, InputRadioGroup, Switch } from '@companycam/slab-web';
import { translate } from 'translations/i18n';

type PrintModalProps = {
  photos: number[];
  isOpen: boolean;
  onRequestClose: () => void;
};

const PrintModal = ({ photos, isOpen, onRequestClose }: PrintModalProps) => {
  const [printDetails, setPrintDetails] = useState(true);
  const [perPage, setPerPage] = useState('1perpage');

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPerPage(event.target.value);
  };

  const printPhotos = () => {
    const params = new URLSearchParams({
      per_page: `${perPage}`,
      include_metadata: `${printDetails}`,
    });
    photos.forEach((photo) => params.append('image_ids[]', `${photo}`));
    window.location.href = `/print?${params}`;
  };

  return (
    <Modal
      isOpen={isOpen}
      ariaHideApp={false}
      onRequestClose={onRequestClose}
      contentLabel={translate('photos.printModal.modalTitlePrintPhotos')}
      overlayClassName="modal"
      className="modal-content-wrap"
    >
      <ActionLink className="modal-close-button" onClick={onRequestClose}>
        <i className="mdi mdi-close" />
      </ActionLink>
      <h3 className="modal-title">
        {translate('photos.printModal.modalTitlePrintPhotos')}
      </h3>
      <form>
        <Switch
          id="print_details"
          label={translate('photos.printModal.instructions')}
          pressed={printDetails}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            setPrintDetails(!printDetails);
          }}
        />

        <InputRadioGroup
          id="per_page"
          label="Photos per page"
          options={[
            {
              label: translate('photos.printModal.1perpage'),
              value: '1perpage',
            },
            {
              label: translate('photos.printModal.2perpage'),
              value: '2perpage',
            },
            {
              label: translate('photos.printModal.4perpage'),
              value: '4perpage',
            },
            {
              label: translate('photos.printModal.10perpage'),
              value: '10perpage',
            },
          ]}
          selectedValue={perPage}
          status="normal"
          onChange={handleOnChange}
          style={{ marginTop: 'var(--cc_size_spacing_l)' }}
        />
        <div className="btn-container full">
          <Button color="primary" onClick={printPhotos}>
            {translate('photos.printModal.printPhotos')}{' '}
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default PrintModal;
